import React, { useState } from "react";
import { StatusDiv, StatusSection } from "../Invoice/InvoiceStyles";
import { IntranetInvoiceStatusSidebar } from "./IntranetInvoiceStatusSidebar";

export const IntranetStatusSectionDetails = (props) => {
  const { invoice } = props;

  const { status } = invoice;

  const { problems } = status;

  const [showSidebar, updateShowSidebar] = useState(false);

  const toggleStatusSidebar = () => {
    updateShowSidebar(!showSidebar);
  };

  const numberProblems = problems.length;

  const text =
    numberProblems === 0
      ? "SIN RESTRICCIONES"
      : `${numberProblems} RESTRICCI${numberProblems === 1 ? "ÓN" : "ONES"}`;
  return (
    <>
      <StatusSection onClick={toggleStatusSidebar}>
        <StatusDiv
          className="status"
          status={numberProblems === 0 ? "ok" : "problem"}
        >
          <span>{text}</span>
        </StatusDiv>
      </StatusSection>
      {showSidebar && (
        <IntranetInvoiceStatusSidebar
          volante={invoice}
          onOutsideClick={toggleStatusSidebar}
        />
      )}
    </>
  );
};
